import UserDetailPage from "./UserDetailPage";
import AdminStateGroupDetailPage from "./AdminStateGroupDetailPage";

export default class RegionalUserDetailPage extends UserDetailPage {
  static PageInfo = {
    
    parent: AdminStateGroupDetailPage,
    hidden:true,
    path: "/Admin/StateGroup/:id/User/:target",
    name: "menu.franchisee",
    access: { 1: true },
    permission: { "CONFIGURATION_USERS_ACCESSING": true },
    icon: "store"
  }
}  